/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import { PLAY } from '@/store/types';
import { StoreActionEnv } from '@/store/actions';
import * as api from '@/api/play';
import { PlayStartData } from '@/api/types/play';

export interface StorePlayStartState extends PlayStartData {
  started: boolean;
}

export default {
  namespaced: true,
  state: {
    started: false,
    banners: null,
    engines: null,
    onlines: null,
    sorts: null,
  },
  getters: {},
  actions: {
    [PLAY.GET_START]({ state, commit }: StoreActionEnv<StorePlayStartState>) {
      if (!state.started) {
        return new Promise((resolve, reject) => {
          api.getStart().then((res) => {
            commit(PLAY.GET_START, res.data);
            resolve();
          }).catch(reject);
        });
      }
      return Promise.resolve();
    },
  },
  mutations: {
    [PLAY.GET_START](state: StorePlayStartState, { banners, engines, sorts, onlines, orderExceptions }: PlayStartData) {
      state.banners = banners;
      state.engines = engines;
      state.onlines = onlines;
      state.sorts = sorts;
      state.orderExceptions = orderExceptions;
    },
  },
};
